import {
  ProfessionsType,
  ParceProfessionsType,
  MapedProfessionsType,
  Professions,
} from './types';

const parse = (data: Professions): Readonly<ParceProfessionsType> =>
  Object.freeze({
    id: data!.id || '',
    title: data!.name || '',
    name: data!.name || '',
    image: data.image && data.image.little ? data.image.little : '',
    competencesCount: data!.competences_count || null,
    eventsCount: data!.events_count || null,
  });

const parseProfessions = (data: ProfessionsType): MapedProfessionsType =>
  data.map((item: Professions) => parse(item));

export default parseProfessions;



// WEBPACK FOOTER //
// ./src/services/api/professions/utils/parseProfessions.ts